import React from "react";

// Importing all created components
// import Sidebar from "../Sidebar/Sidebar";
// import Navbar from "../Navbar/Navbar";
import Footer from "../footer/PublicFooter";
import PublicHeader from "../header/PublicHeader";
import PublicNavbar from "../navbar/PublicNavbar";
import { Outlet } from "react-router-dom";

// Pass the child props
export default function PublicLayout({ children }) {
  return (
    <div className="flex flex-col h-[100%]">
      <PublicHeader />
      <div className="relative z-10 -mt-10 sm:mx-0 md:mx-[5%] flex-grow flex flex-col">
        <PublicNavbar />
        <div className="bg-white bg-opacity-70 p-0 px-2 flex-grow">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
